export enum NotificationDismissType {
    NoDismissable = 'NoDismissable',
    Dismissable = 'Dismissable',
    AutoDismiss = 'AutoDismiss'
}
